import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import useKeyPress from 'Hooks/useKeyPress';
import {
  selectCredentialId,
  selectCredentialPassword,
  selectCredentialUsername
} from 'store/Credentials/selectors';
import { Wrapper, ButtonWrapper, Key } from './styled';
import {
  Title,
  CreateButton,
  NextIcon
} from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal/components/Header/styled';
import { Cancel } from 'Common/Components/Button/styled';
import {
  saveCredential,
  setCreateCredentialError,
  showCreateEditModal
} from 'store/Credentials/actions';

const Header = ({ isVulnDetail }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const id = useSelector(selectCredentialId);
  const username = useSelector(selectCredentialUsername);
  const password = useSelector(selectCredentialPassword);
  const text = id ? 'Save' : 'Create';
  const title = id
    ? intl.formatMessage({ id: 'credentials.modalCreateEdit.editTitle' })
    : intl.formatMessage({ id: 'credentials.modalCreateEdit.createTitle' });
  const enabled = username && password;

  const closeModal = () => dispatch(showCreateEditModal(false));

  const handleCreateCredential = () => {
    dispatch(saveCredential(isVulnDetail));
    closeModal();
  };

  const showErrorModal = () => dispatch(setCreateCredentialError(true));

  useKeyPress(() => {
    enabled ? handleCreateCredential() : showErrorModal();
  }, ['Enter']);

  useKeyPress(() => {
    closeModal();
  }, ['Escape']);

  return (
    <Wrapper>
      <Key />
      <Title children={ title } />
      <ButtonWrapper>
        <Cancel onClick={ closeModal } children="Cancel" />
        <CreateButton
          onClick={ enabled ? handleCreateCredential : showErrorModal }
        >
          <>{text}</>
          <NextIcon />
        </CreateButton>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default Header;
